import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';

const Field = ({ label, ...props }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    <input {...props} className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
  </div>
);

const CompanyRegisterPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    companyName: '', companyEmail: '', companyPhone: '', companyAddress: '',
    adminName: '', adminEmail: '', adminPhone: '', adminPassword: '', adminPasswordConfirm: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState(false);

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.adminPassword !== form.adminPasswordConfirm) {
      setError('كلمتا المرور غير متطابقتين');
      return;
    }
    if (form.adminPassword.length < 6) {
      setError('كلمة المرور يجب أن تكون 6 أحرف على الأقل');
      return;
    }

    setLoading(true);
    try {
      await api.post('/companies/register', form);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || 'حدث خطأ. يرجى المحاولة مجدداً.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-900 to-blue-600 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-10 text-center" dir="rtl">
          <div className="text-6xl mb-4">✅</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-3">تم تقديم الطلب بنجاح!</h2>
          <p className="text-gray-500 text-sm mb-6">
            سيتم مراجعة طلبك من قبل المدير العام. ستتلقى إشعاراً على بريدك الإلكتروني خلال 24-48 ساعة عند قبول الطلب.
          </p>
          <Link to="/login" className="bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-800">
            العودة لتسجيل الدخول
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 to-blue-600 p-4" dir="rtl">
      <div className="max-w-2xl mx-auto">
        <div className="text-center text-white py-8">
          <div className="text-5xl mb-2">🚌</div>
          <h1 className="text-3xl font-bold">سافر — تسجيل شركة جديدة</h1>
          <p className="text-blue-200 mt-2">انضم إلى منصة سافر وابدأ في إدارة رحلاتك</p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-6">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-600 rounded-lg px-4 py-3 mb-6 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={submit} className="space-y-8">
            {/* Company Info */}
            <div>
              <h2 className="text-lg font-bold text-gray-800 border-b pb-2 mb-4 flex items-center gap-2">
                🏢 بيانات الشركة
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Field label="اسم الشركة *" type="text" placeholder="شركة النقل الوطني" required value={form.companyName} onChange={set('companyName')} />
                <Field label="البريد الإلكتروني للشركة *" type="email" placeholder="info@company.com" required value={form.companyEmail} onChange={set('companyEmail')} />
                <Field label="رقم هاتف الشركة *" type="tel" placeholder="0500000000" required value={form.companyPhone} onChange={set('companyPhone')} />
                <Field label="العنوان" type="text" placeholder="الرياض، المملكة العربية السعودية" value={form.companyAddress} onChange={set('companyAddress')} />
              </div>
            </div>

            {/* Admin Info */}
            <div>
              <h2 className="text-lg font-bold text-gray-800 border-b pb-2 mb-4 flex items-center gap-2">
                👤 بيانات مدير الشركة
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Field label="الاسم الكامل *" type="text" placeholder="محمد أحمد" required value={form.adminName} onChange={set('adminName')} />
                <Field label="رقم الهاتف *" type="tel" placeholder="0500000001" required value={form.adminPhone} onChange={set('adminPhone')} />
                <Field label="البريد الإلكتروني *" type="email" placeholder="admin@company.com" required value={form.adminEmail} onChange={set('adminEmail')} />
                <div /> {/* spacer */}
                <Field label="كلمة المرور *" type="password" placeholder="6 أحرف على الأقل" required value={form.adminPassword} onChange={set('adminPassword')} />
                <Field label="تأكيد كلمة المرور *" type="password" placeholder="أعد إدخال كلمة المرور" required value={form.adminPasswordConfirm} onChange={set('adminPasswordConfirm')} />
              </div>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-sm text-yellow-800">
              ⚠️ سيتم مراجعة طلبك من قبل إدارة المنصة قبل تفعيل حسابك. قد تستغرق العملية حتى 48 ساعة.
            </div>

            <button type="submit" disabled={loading}
              className="w-full bg-blue-700 hover:bg-blue-800 disabled:bg-blue-400 text-white font-bold py-3 rounded-lg text-lg transition">
              {loading ? 'جاري إرسال الطلب...' : 'تقديم طلب التسجيل'}
            </button>
          </form>

          <p className="text-center text-sm text-gray-400 mt-6">
            لديك حساب بالفعل؟{' '}
            <Link to="/login" className="text-blue-600 hover:underline font-medium">تسجيل الدخول</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompanyRegisterPage;
